import {
    Login,
    Home,
    Term,
    ForgotPassword,
    SearchResult,
    DetailTour,
    // Cart,
    BookNow,
    Booking,
    AccountSetting,
    Favorites,
    Quotes,
    BookingDetail,
    LinkAgentAccount,
    // Accounting,
    MyAccount,
    MyAccountSetting,
    NotFound,
    UpdatePassword,
    PaymentWrapper,
    SignUp,
    PrivacyPolicy,
    Discounts,
    Earnings,
    PointsLearnMore,
    CommissionAgent,
    ShareQuotesWithContact,
    ShareQuotesWithEmail,
    PendingRequests,
    TripPlanner,
    MyTrips,
    CustomerQuote,
    Profile,
    CmsPage,
    CmsShowcase,
    CmsHome,
    Blog,
    BlogPost,
} from "@pages";
import { IBreadcrumbs, IRoute } from "@interfaces";
import PaymentFail from "src/Pages/PaymentFail";
import { SetupOrderCheckComponent } from "@components";
import { Cart } from "src/Module/Checkout/Cart";
import { QuotesDetails } from "src/Module/Checkout/QuotesDetail";
import { CommissionLearnMore } from "src/Pages/CommissionLearnMore";

export const PATH_HOME = "/";
export const PATH_LOGIN = "/login";
export const PATH_SIGNUP = "/signup";
export const PATH_TERM = "/booking-terms-and-conditions";
export const PATH_FORGOT_PASSWORD = "/forgot-password";
export const PATH_SEARCH_RESULT = "/search-result";
export const PATH_DETAIL_TOUR = "/detail-tour";
export const PATH_CHECK_AVAILABILITY = "/check-availability";
export const PATH_CART = "/cart";
export const PATH_BOOK_NOW = "/book-now";
export const PATH_BOOKING = "/booking";
export const PATH_MENU_SETTING = "/menu-setting";
export const PATH_FAVORITES = "/favorites";
export const PATH_QUOTES = "/quotes";
export const PATH_BOOKING_DETAIL = "/booking-detail";
export const PATH_MY_ACCOUNT = "/my-account";
export const PATH_ACCOUNT = "/account";
export const PATH_UPDATE_PASSWORD = "/update-password";
export const PATH_PAYMENT_WRAPPER = "/payment-wrapper";
export const PATH_ORDER_SUCCESS = "/order/success";
export const PATH_LINK_AGENT_ACCOUNT = "/link-agent-account";
export const PATH_PAYMENT_FAIL = "/paymentfail";
export const PATH_ORDER_CHECK = "/order/check";
export const PATH_PRIVACY_POLICY = "/privacy-policy";
export const PATH_DISCOUNTS = "/about/discounts";
export const PATH_POINTS_HISTORY = "/points-history";
export const PATH_POINTS_LEARN_MORE = "/about/rewards";
export const PATH_COMMISSION_LEARN_MORE = "/about/commission";
export const PATH_SHARE_QUOTES_WITH_CONTACT = "/share/quotes-with-contact";
export const PATH_SHARE_QUOTES_WITH_EMAIL = "/share/quotes-with-email";
export const PATH_COMMISSION_AGENT = "/commission-agent";
export const PATH_PENDING_REQUESTS = "/quotes/pending";
export const PATH_TRIP_PLANNER = "/trip-planner";
export const PATH_MY_TRIPS = "/my-trips";
export const PATH_CUSTOMER_QUOTE = "/customerQuote";
export const PATH_PROFILE = "/profile";
export const PATH_BLOG = "/blog";
export const PATH_CMS_SHOWCASE = "/cms";
export const PATH_CMS_HOME = "/cms/home";
export const PATH_CMS_PAGE = "/:pageSlug";

export const authPath = [
    PATH_LOGIN,
    PATH_SIGNUP,
    PATH_FORGOT_PASSWORD,
    PATH_DISCOUNTS,
    PATH_POINTS_LEARN_MORE,
    PATH_COMMISSION_LEARN_MORE,
];

export const normalPath = [
    PATH_HOME,
    PATH_DETAIL_TOUR,
    PATH_SEARCH_RESULT,
    PATH_CHECK_AVAILABILITY,
    PATH_PRIVACY_POLICY,
    PATH_TERM,
];

export const protectedPath = [
    PATH_BOOK_NOW,
    PATH_BOOKING,
    PATH_ACCOUNT,
    PATH_MENU_SETTING,
    PATH_FAVORITES,
    PATH_BOOKING_DETAIL,
    PATH_QUOTES,
    PATH_MY_ACCOUNT,
    PATH_UPDATE_PASSWORD,
    PATH_ORDER_SUCCESS,
    PATH_LINK_AGENT_ACCOUNT,
    PATH_POINTS_HISTORY,
    PATH_MY_TRIPS,
    PATH_PROFILE,
    PATH_TRIP_PLANNER + "/", // saved-trip reopen requires auth; bare /trip-planner stays public
];

export const public_route: Array<IRoute> = [
    { path: PATH_HOME, element: Home },
    { path: PATH_SEARCH_RESULT, element: SearchResult },
    { path: PATH_DETAIL_TOUR + "/:id", element: DetailTour },
    { path: PATH_ORDER_CHECK, element: SetupOrderCheckComponent },
    { path: PATH_PRIVACY_POLICY, element: PrivacyPolicy },
    { path: PATH_TERM, element: Term },
    { path: PATH_DISCOUNTS, element: Discounts },
    { path: PATH_POINTS_LEARN_MORE, element: PointsLearnMore },
    { path: PATH_COMMISSION_LEARN_MORE, element: CommissionLearnMore },
    { path: PATH_CART + "/:idSaveCart", element: Cart },
    { path: PATH_CART, element: Cart },
    { path: PATH_BOOK_NOW, element: BookNow },
    { path: PATH_PAYMENT_FAIL, element: PaymentFail },
    { path: PATH_TRIP_PLANNER, element: TripPlanner },
    { path: PATH_CUSTOMER_QUOTE + "/:quoteId/:quoteToken/:randomString", element: CustomerQuote },
    { path: PATH_BLOG, element: Blog },
    { path: PATH_BLOG + "/:slug", element: BlogPost },
    // Temporary CMS/SEO feature preview hub. Static route ranks above the
    // catch-all `/:pageSlug` below. Remove once the CMS is fully converted.
    { path: PATH_CMS_SHOWCASE, element: CmsShowcase },
    // Temporary CMS-driven homepage preview. The live `/` homepage keeps its
    // original banner; this route shows the backend-composed version.
    { path: PATH_CMS_HOME, element: CmsHome },
    // Catch-all CMS page slug. React Router ranks static routes above this
    // dynamic segment, so it only matches otherwise-unhandled single-segment
    // paths and renders a graceful not-found for unknown slugs. Keep LAST.
    { path: PATH_CMS_PAGE, element: CmsPage },
];

export const protected_route: Array<IRoute> = [
    { path: PATH_BOOKING, element: Booking },
    { path: PATH_MENU_SETTING, element: AccountSetting },
    { path: PATH_FAVORITES, element: Favorites },
    { path: PATH_QUOTES, element: Quotes },
    { path: PATH_SHARE_QUOTES_WITH_CONTACT, element: ShareQuotesWithContact },
    { path: PATH_SHARE_QUOTES_WITH_EMAIL, element: ShareQuotesWithEmail },
    { path: PATH_PENDING_REQUESTS, element: PendingRequests },
    { path: PATH_MY_TRIPS, element: MyTrips },
    { path: PATH_TRIP_PLANNER + "/:tripId", element: TripPlanner },
    { path: PATH_QUOTES + "/:quoteId", element: QuotesDetails },
    { path: PATH_BOOKING_DETAIL + "/:id" + "/:tripId", element: BookingDetail },
    { path: PATH_MY_ACCOUNT, element: MyAccountSetting },
    { path: PATH_PROFILE, element: Profile },
    { path: PATH_ACCOUNT, element: MyAccount },
    { path: PATH_UPDATE_PASSWORD, element: UpdatePassword },
    { path: PATH_PAYMENT_WRAPPER, element: PaymentWrapper },
    { path: PATH_LINK_AGENT_ACCOUNT, element: LinkAgentAccount },
    { path: PATH_POINTS_HISTORY, element: Earnings },
    { path: PATH_COMMISSION_AGENT, element: CommissionAgent },
    { path: "**", element: NotFound },
];

export const auth_route: Array<IRoute> = [
    { path: PATH_LOGIN, element: Login },
    { path: PATH_SIGNUP, element: SignUp },
    { path: PATH_FORGOT_PASSWORD, element: ForgotPassword },
    { path: PATH_PAYMENT_WRAPPER, element: PaymentWrapper },
    { path: "**", element: NotFound },
];

// breadcrumbs
export const CartBreadcrumbs: IBreadcrumbs[] = [
    {
        title: "Home",
        link: PATH_HOME,
    },
    {
        title: "Cart",
        link: PATH_CART,
    },
];
export const QuotesBreadcrumbs: IBreadcrumbs[] = [
    { title: "Home", link: PATH_HOME },
    { title: "Quotes", link: PATH_QUOTES },
];

export const BookNowBreadcrumbs: IBreadcrumbs[] = [
    { title: "Home", link: PATH_HOME },
    { title: "Book Now", link: PATH_BOOK_NOW },
];
